import { motion } from 'framer-motion';
import './PageHero.css';

export default function PageHero({ title, highlight, subtitle, bgImage }) {
  return (
    <section
      className="page-hero"
      style={{ backgroundImage: bgImage ? `url(${bgImage})` : undefined }}
    >
      <div className="page-hero__overlay" />
      <div className="page-hero__content container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <p className="page-hero__label section-label">AL-AMANAT Travels</p>
          <h1 className="page-hero__title">
            {title} {highlight && <span>{highlight}</span>}
          </h1>
          {subtitle && <p className="page-hero__subtitle">{subtitle}</p>}
        </motion.div>
      </div>
    </section>
  );
}